import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7jc8fy9bgs: FaireBrandEntity = {
  token: "b_7jc8fy9bgs",
  type: "brand",
  name: "Nova Ceramics Travel Mugs",
  avatarUrl:
    "https://cdn.faire.com/fastly/fea87e27ccb1093b135a156f307eeffbc04fcab379aca3bb73a9dc5d9b2f7f8e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a8e94386cfb34a17265a7380d6c098f774bc0fad2b45a90175f9edc2fabe4267.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fea87e27ccb1093b135a156f307eeffbc04fcab379aca3bb73a9dc5d9b2f7f8e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a8e94386cfb34a17265a7380d6c098f774bc0fad2b45a90175f9edc2fabe4267.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 103,
  rating: 4.9,
  reviewCount: 76,
  isInsider: true,
  description:
    "At Nova Ceramics, we believe everyday moments deserve beauty, intention, and sustainability. That’s why we create premium, handcrafted stoneware travel mugs that elevate your daily ritual and reduce waste—without compromising on style.\n\nEach mug is individually glazed by hand, meaning no two are exactly alike. Our high-fired stoneware is durable, microwave- and dishwasher-safe, and finished with food-safe, toxin-free glazes. Every cup comes with a BPA-free silicone lid and heat-resistant sleeve, blending form and function for people on the go.\n\nInspired by nature, our glaze palettes—from soft earth tones to cosmic blues—make every mug a photogenic collectible and a perfect gift for coffee lovers. Whether it's a peaceful morning brew or a midday pick-me-up, Nova Ceramics adds elegance to every sip.\n\nWe care about craftsmanship, sustainability, and creating pieces that last. Our mugs are loved by eco-conscious shoppers, collectors, and retailers looking to offer products that stand out in both design and intention.\n\nStocking Nova Ceramics means attracting customers who value quality, mindful living, and artful design—all in one beautiful, reusable mug. 💫",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:01.076Z",
    importedBy: "entity-db-cli",
  },
};
